import { useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'

import Header from '../../components/header/Header'
import Sidebar from '../../components/sidebar/Sidebar'
import './Dashboard.css'

export default function DashboardPage({ refreshUser }: { refreshUser: () => void }) {
  const navigate = useNavigate()
  const [logged, setLogged] = useState<boolean>(true)
  const [className, setClassName] = useState<string>('container')

  useEffect(() => {
    if (!localStorage.getItem('token')) {
      refreshUser()
      setLogged(false)
    }
  }, [])

  useEffect(() => {
    const allowedRoutes = [/solicitacoes/, /form-leads/, /entrega-de-trabalhos/]

    if (allowedRoutes.some((route) => route.test(window.location.pathname))) {
      setClassName('container-requests')
    } else {
      setClassName('container')
    }
  }, [window.location.pathname])

  useEffect(() => {
    // Rotas liberadas mesmo sem estar logado:
    const allowedRoutes = [/acelera-magenta\/(new|complete|\d{1,})/]

    if (allowedRoutes.some((route) => route.test(window.location.pathname))) {
      return
    }

    if (!logged) {
      navigate('/login')
    }
  }, [logged])

  return (
    <>
      {logged && (
        <>
          <Sidebar />
          <Header refreshUser={refreshUser} />
        </>
      )}
      <div className={className} style={{ marginBottom: '20px' }}>
        <Outlet />
      </div>
    </>
  )
}
